import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "../contexts/UserContext";
import { useEffect, useState } from "react";
import authProvider, { getAccessToken } from "../authProvider";
import { GetCurrentUser } from "../api/users/getCurrentUser";
import { USER_DATA } from "../config/variables";

function PublicRoutes() {
  const { userData, setUserData } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const mfaData = JSON.parse(sessionStorage.getItem("mfa_user_sub") || null);

  useEffect(() => {
    const init = async () => {
      // If secure cookie doesn't exist, stop loading and skip auth check
      if (!getAccessToken()) {
        setLoading(false);
        setLoggedIn(false);
        return;
      }

      setLoading(true);
      try {
        await authProvider.checkAuth();
        try {
          const user_data = await authProvider.getCurrentUser();
          setUserData(user_data);
          setLoggedIn(true);
        } catch {
          // Fallback: use API call
          const { data } = await GetCurrentUser();
          localStorage.setItem(USER_DATA, JSON.stringify(data));
          setUserData(data);
          setLoggedIn(true);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        setUserData(null);
        setLoggedIn(false);
      } finally {
        setLoading(false);
      }
    };

    init();
    // eslint-disable-next-line
  }, []);

  if (mfaData && mfaData.mfa_required) {
    return <Navigate to={`/auth/mfa-${mfaData.mfa_registered ? "verify" : "setup"}`} />;
  }

  if (loading) return <div>Loading...</div>;

  if (userData && loggedIn) return <Navigate to="/" />;

  return <Outlet />;
}

export default PublicRoutes;
